// src/lib/api/apiUtils.ts — Backward-compatible error classes
// All HTTP client logic has moved to jasit-api-kit. This file only provides
// the legacy ApiError / AuthError classes so existing components that
// construct or instanceof-check them keep working.
import { ApiError as JasitApiError } from 'jasit-api-kit';

export class AuthError extends Error {
    statusCode: number;
    redirectTo?: string;

    constructor(message: string, statusCode: number, redirectTo?: string) {
        super(message);
        this.statusCode = statusCode;
        this.redirectTo = redirectTo;
        this.name = 'AuthError';
    }
}

export class ApiError extends Error {
    statusCode: number;
    code?: string;
    errorDetails?: any;

    constructor(message: string, statusCode: number, errorDetails?: any) {
        super(message);
        this.statusCode = statusCode;
        this.errorDetails = errorDetails;
        this.name = 'ApiError';
    }
}

/**
 * Convert any error (including jasit-api-kit ApiError) to a compat ApiError.
 */
export function toCompatError(error: unknown): ApiError {
    if (error instanceof ApiError) return error;
    if (error instanceof JasitApiError) {
        const compat = new ApiError(error.message, error.status, error.details);
        compat.code = error.code;
        return compat;
    }
    if (error instanceof Error) {
        return new ApiError(error.message, (error as any).statusCode ?? (error as any).status ?? 500);
    }
    return new ApiError('An unexpected error occurred', 500);
}
